import { render, staticRenderFns } from "./ElectronicCommerce.vue?vue&type=template&id=ef049648&scoped=true"
import script from "./ElectronicCommerce.vue?vue&type=script&lang=js"
export * from "./ElectronicCommerce.vue?vue&type=script&lang=js"
import style0 from "./ElectronicCommerce.vue?vue&type=style&index=0&id=ef049648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef049648",
  null
  
)

export default component.exports